import React, { forwardRef, memo } from 'react';
import { motion } from "framer-motion"
import { Box, Paper } from "@mui/material"

const framerMotionVariants = {
  section: {
    initial: { scaleY: 0 },
    animate: { scaleY: 1 },
    exit: { scaleY: 0 },
    transition: { duration: 0.2 }
  }
}

const SectionRef = forwardRef((props, ref) =>
  <Box sx={{ m: 3, display: "flex", flex: "1", maxWidth: "900px", zIndex: "5" }} component="section" ref={ref} {...props} />)

const AnimatedSection = motion(SectionRef, { forwardMotionProps: true })

const FullScreenContentBody = ({ children }) => {

  return (
    <AnimatedSection initial='initial' animate='animate' exit='exit' transition='transition' variants={framerMotionVariants.section}>

      <Paper m={3} elevation={6} sx={{ flex: 1 }}>{children}</Paper >

    </AnimatedSection>
  );
}

export default memo(FullScreenContentBody);